function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 9.62983,
  width: 1104,
  height: 560,
  fill: "#00bfa6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M546.975,292.91v65.68a2.29613,2.29613,0,0,1-2.29,2.29h-1.62989V703.03a35.702,35.702,0,0,1-35.70007,35.7H293.56509a35.69346,35.69346,0,0,1-35.69006-35.7V372.88h-1.18a1.6176,1.6176,0,0,1-1.62-1.61V333.89a1.61971,1.61971,0,0,1,1.62-1.62h1.18V318.19H256.685a1.69647,1.69647,0,0,1-1.68994-1.7V279.62a1.69432,1.69432,0,0,1,1.68994-1.69H257.875V258.71h-1.21008a1.498,1.498,0,0,1-1.5-1.5V237.09a1.5066,1.5066,0,0,1,1.5-1.51H257.875V194.84a35.69136,35.69136,0,0,1,35.69006-35.69H507.355a35.69991,35.69991,0,0,1,35.70007,35.69v95.78H544.685A2.29608,2.29608,0,0,1,546.975,292.91Z",
  transform: "translate(-48 -159.14996)",
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "948.7 9.63 476.02 334.13 443.76 287.14 848 9.63 948.7 9.63",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "1104 9.63 1104 56.62 439.02 513.13 406.76 466.14 1071.75 9.63 1104 9.63",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  points: "1104 147.95 1104 217.08 590.46 569.63 489.75 569.63 1104 147.95",
  opacity: 0.1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 30.17236,
  y: 578.66157,
  width: 1039.82764,
  height: 2,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 825.40456,
  y: 555.5884,
  width: 52,
  height: 52,
  transform: "translate(445.81522 -544.65238) rotate(35.37103)",
  fill: "#f0f0f0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M857.17236,628.772a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,857.17236,628.772Zm0-22a10,10,0,1,0,10,10A10.01114,10.01114,0,0,0,857.17236,606.772Z",
  transform: "translate(-48 -159.14996)",
  fill: "#3f3d56"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M618.17236,259.772a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,618.17236,259.772Zm0-22a10,10,0,1,0,10,10A10.01114,10.01114,0,0,0,618.17236,237.772Z",
  transform: "translate(-48 -159.14996)",
  fill: "#f0f0f0"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 137.14746,
  y: 506.09467,
  width: 2,
  height: 74.41113,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 138.14769,
  cy: 506.0943,
  r: 10.52282,
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M186.14769,711.10553s-1.50326-32.33193-32.32009-28.57378",
  transform: "translate(-48 -159.14996)",
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 325.47864,
  y: 18.3068,
  width: 39.82343,
  height: 8.08642,
  rx: 2.54189,
  fill: "#e6e8ec"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 375.91006,
  cy: 22.35,
  r: 4.58665,
  fill: "#e6e8ec"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M525.96,201.89979v504.09a22.65047,22.65047,0,0,1-22.65,22.64H298.66a22.61062,22.61062,0,0,1-22.65-22.64v-504.09a22.64906,22.64906,0,0,1,22.65-22.65h30.63v3.93a18.65016,18.65016,0,0,0,18.65,18.65H452.02a18.65011,18.65011,0,0,0,18.65-18.65v-3.93h32.64A22.64266,22.64266,0,0,1,525.96,201.89979Z",
  transform: "translate(-48 -159.14996)",
  fill: "#00bfa6"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 238,
  y: 168.62983,
  width: 232,
  height: 113,
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 238,
  y: 356.62983,
  width: 232,
  height: 113,
  fill: "#3f3d56"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 446,
  cy: 81.62983,
  r: 20,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "455 80.987 446.643 80.987 446.643 72.63 445.357 72.63 445.357 80.987 437 80.987 437 82.273 445.357 82.273 445.357 90.63 446.643 90.63 446.643 82.273 455 82.273 455 80.987",
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M379.40863,405.37072c6.07317,22.45,26.87512,36.35394,26.87512,36.35394s10.95541-22.49485,4.88225-44.94491-26.87512-36.35394-26.87512-36.35394S373.33547,382.92066,379.40863,405.37072Z",
  transform: "translate(-48 -159.14996)",
  fill: "#fff"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M388.33272,400.546c16.66484,16.22255,18.70033,41.1604,18.70033,41.1604s-24.98356-1.36412-41.64841-17.58667-18.70033-41.1604-18.70033-41.1604S371.66787,384.3234,388.33272,400.546Z",
  transform: "translate(-48 -159.14996)",
  fill: "#00bfa6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M379.40863,593.37072c6.07317,22.45005,26.87512,36.35394,26.87512,36.35394s10.95541-22.49485,4.88225-44.94491-26.87512-36.35394-26.87512-36.35394S373.33547,570.92066,379.40863,593.37072Z",
  transform: "translate(-48 -159.14996)",
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M388.33272,588.546c16.66484,16.22255,18.70033,41.1604,18.70033,41.1604s-24.98356-1.36412-41.64841-17.58667-18.70033-41.1604-18.70033-41.1604S371.66787,572.3234,388.33272,588.546Z",
  transform: "translate(-48 -159.14996)",
  fill: "#00bfa6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M434.65747,593.37072c-6.07316,22.45005-26.87511,36.35394-26.87511,36.35394s-10.95541-22.49485-4.88225-44.94491,26.87512-36.35394,26.87512-36.35394S440.73064,570.92066,434.65747,593.37072Z",
  transform: "translate(-48 -159.14996)",
  fill: "#fff"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M425.73339,588.546c-16.66485,16.22255-18.70034,41.1604-18.70034,41.1604s24.98357-1.36412,41.64841-17.58667,18.70034-41.1604,18.70034-41.1604S442.39824,572.3234,425.73339,588.546Z",
  transform: "translate(-48 -159.14996)",
  fill: "#00bfa6"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1024,280.06184h-19.74115V260.32069H1024Zm-18.2226-1.51855h16.70405v-16.704H1005.7774Z",
  transform: "translate(-48 -159.14996)",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.64387,727.14192l-13.4651-14.43621,14.43622-13.46509,13.46509,14.43621ZM1024.325,712.78041l11.39354,12.21526,12.21525-11.39354-11.39354-12.21526Z",
  transform: "translate(-48 -159.14996)",
  fill: "#f0f0f0"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.3101,
  cy: 101.30692,
  r: 10.07861,
  fill: "#f0f0f0"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M185.3101,289.57287a29.116,29.116,0,1,1,29.116-29.116A29.14864,29.14864,0,0,1,185.3101,289.57287Zm0-55.99228a26.8763,26.8763,0,1,0,26.87629,26.87629A26.90708,26.90708,0,0,0,185.3101,233.58059Z",
  transform: "translate(-48 -159.14996)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 646,
  y: 214.62983,
  width: 328,
  height: 27,
  fill: "#f0f0f0"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 687.5,
  y: 277.62983,
  width: 245,
  height: 10.45714,
  fill: "#f0f0f0"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 687.5,
  y: 294.47745,
  width: 245,
  height: 10.45714,
  fill: "#f0f0f0"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 687.5,
  y: 311.32507,
  width: 245,
  height: 10.45714,
  fill: "#f0f0f0"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 687.5,
  y: 328.17268,
  width: 245,
  height: 10.45714,
  fill: "#f0f0f0"
});

function SvgMobileScreenPic1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a07da818-cf00-4494-8aa7-da1849f04f60",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1104,
    height: 580.70112,
    viewBox: "0 0 1104 580.70112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mobile_images") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileScreenPic1);
export default __webpack_public_path__ + "static/media/mobile-screen-pic-1.4cdd0668.svg";
export { ForwardRef as ReactComponent };